<template>
  <div class="departures w-100">
    <div class="board">
      <div class="board-head pl-3">
        <span>{{ detail.group }}</span>
        <button
          class="board-close"
          @click="close"
        >
          <i class="icon-angle-left m-0" />volver
        </button>
      </div>
      <div class="board-content">
        <div class="departures">
          <table class="tbl">
            <tr class="text-nowrap">
              <th><span>SALIDA</span></th>
              <th><span /></th>
              <th><span>EMBARQUE</span></th>
              <th><span>DESDE</span></th>
              <th>&nbsp;</th>
              <th><span>DISP. MICRO</span></th>
            </tr>
            <tr
              v-for="(item, i) in departures"
              :key="i"
              @click="$router.push({ name: 'departure', params: { id: item.id } })"
            >
              <td>
                <span class="table-span">{{ item.alias }} {{ item.name }}</span>
              </td>
              <td>
                <span
                  class="pill pill-green pill-xs"
                  v-if="item.fresh"
                >¡NUEVO!</span>
                <span
                  class="pill pill-red pill-xs"
                  v-if="item.promo"
                >¡PROMO!</span>
              </td>
              <td>
                <strong class="txt-orange">{{ item.origin }}</strong>
              </td>
              <td>
                <strong>{{ item.currency }}{{ item.initial_price }}</strong>
              </td>
              <td>
                <router-link
                  class="tbl-link"
                  :to="{ name: 'departure', params: { id: item.id } }"
                  append
                >
                  VER DETALLE
                </router-link>
              </td>
              <td style="width: 1rem;">
                <span
                  class="pill pill-black"
                  v-if="item.free"
                >
                  <span class="ico ico-bus ico-xs">{{ item.free }}</span>
                </span>
                <span
                  class="pill pill-orange"
                  v-else
                >CONSULTAR</span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    detail () {
      return this.$store.state.departures.find(departure => departure.group == this.$route.params.id)
    },
    departures () {
      return this.$store.state.departures.filter(departure => departure.group == this.$route.params.id)
    }
  },

  methods: {
    close () {
      this.$router.push({ name: 'departures', query: { grid: null } })
    }
  }
}
</script>
